import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function TransporteAnexo21Y22RMF2026DatosGenerales() {
  return <CategoryPage category="transporteAnexo21Y22Rmf2026DatosGenerales2026" pageTitle="Datos Generales 2026" />;
}

export default TransporteAnexo21Y22RMF2026DatosGenerales;
